export default __webpack_public_path__ + "static/kutu-bicak-izi-d5b68e05427519c91dd4235582c9e45a.png";